import PlusIcon from "@/../../public/images/plus-icon.svg";
import BriefcaseIcon from "@/../../public/images/lucide_briefcase-business.svg";
import LocationIcon from "@/../../public/images/locationIcon.svg";
import SearchIcon from "@/../../public/images/search.svg";
import HomeLine from "@/../../public/images/home-line.svg";
import FocusLine from "@/../../public/images/focus-line.svg";
import NameSeenline from "@/../../public/images/name-seen-line.svg";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useState, useEffect, useRef } from "react";

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, FreeMode } from "swiper/modules";
import "swiper/css";
import { Link, useNavigate } from "react-router-dom";
import { CategoryApi, homeApi } from "../service/apis/pages.api";
import Loader from "../common/Loader/loader";
import { RootState } from "../store/store";
import { useSelector } from "react-redux";

interface ResponseItem {
    content: string;
    formFieldRepeater: any;
    type: any;
}

const Home = () => {
    const [responseData, setResponseData] = useState<ResponseItem[]>([]);
    const [categoryData, setCategoryData] = useState([]);
    const sectionRef = useRef<HTMLDivElement | null>(null);
    const [isVisible, setIsVisible] = useState(false);
    const [, setIsLoading] = useState(false);

    const [error, setError] = useState("");
    const navigate = useNavigate();

    const [, setFormValues] = useState({
        industry: "",
        location: "",
    });
    const { isLoggedIn } = useSelector((state: RootState) => state.authSlice);


    const handleSubmit = (e: any) => {
        e.preventDefault();

        const formData = new FormData(e.currentTarget);
        const industry = formData.get("industry") as string;
        const location = formData.get("location") as string;

        if (!industry && !location) {
            setError("Both fields are required.");
            return;
        }

        setError("");

        setFormValues({ industry, location });
        navigate("/job-listing", { state: { industry, location } });
    };

    const homeContents = async () => {
        setIsLoading(true);
        try {
            const response = await homeApi();
            //console.log(response);
            setResponseData(response?.pageData?.pageContent);
        } catch (error) {
            console.error("Catch Error: ", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleJobCategorySearch = async (categoryId: any) => {
        //console.log(categoryId)
        navigate("/job-listing", { state: { categoryId } });

    }

    // Category APi Call
    const catContents = async () => {
        setIsLoading(true);
        try {
            const responsee = await CategoryApi();
            //console.log(responsee);
            setCategoryData(responsee?.categories);
        } catch (error) {
            console.error("Catch Error: ", error);
        } finally {
            setIsLoading(false);
        }
    };
    // Category APi Call ends

    useEffect(() => {
        homeContents();
        catContents();
    }, []);

    const brand_logos = responseData[4]?.formFieldRepeater;
    const repeater_texts = responseData[11]?.formFieldRepeater;
    // const browse_texts = responseData[14]?.formFieldRepeater;
    const network_texts = responseData[20]?.formFieldRepeater;
    const success_texts = responseData[23]?.formFieldRepeater;

    //console.log(categoryData);

    const decodeHtml = (html = "") => {
        const txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
    };

    const sanitizeData = (htmldata = "") => {
        const sanitizedDescription = decodeHtml(htmldata);
        return (
            <div dangerouslySetInnerHTML={{ __html: sanitizedDescription }}></div>
        );
    };



    // const [count, setCount] = useState(0);
    // const target = 200; // Target number to reach    

    // useEffect(() => {
    //     let currentCount = 0;
    //     const interval = setInterval(() => {
    //       currentCount += 5; // Increase count smoothly
    //       if (currentCount >= target) {
    //         clearInterval(interval);
    //         setCount(target);
    //       } else {
    //         setCount(currentCount);
    //       }
    //     }, 50); // Speed of counting

    //     return () => clearInterval(interval); // Cleanup on unmount
    //   }, []);
    interface SuccessItem {
        content: string;
    }
    const [counts, setCounts] = useState<string[]>([]);

    useEffect(() => {
        if (!isVisible || !success_texts || success_texts.length === 0) return;

        // Initialize counts as empty strings
        setCounts(new Array(success_texts.length).fill("0"));

        const intervals: NodeJS.Timeout[] = success_texts.map((scs: SuccessItem[], index: number) => {
            let originalContent = scs[0]?.content.trim() || "";
            let isPercentage = originalContent.includes("%");
            let isPlus = originalContent.includes("+");

            // Remove `%` and `+` before parsing
            let rawNumber = parseFloat(originalContent.replace(/[%+,\s]/g, "")) || 0;

            let currentCount = 0;
            let increment = Math.max(1, Math.ceil(rawNumber / 50)); // Ensure at least 1 increment

            const interval = setInterval(() => {
                currentCount += increment;
                if (currentCount >= rawNumber) {
                    currentCount = rawNumber;
                    clearInterval(interval);
                }

                setCounts((prevCounts) => {
                    const newCounts = [...prevCounts];
                    let formattedNumber =
                        rawNumber >= 1000
                            ? currentCount.toLocaleString()
                            : isPercentage
                                ? `${currentCount}%`
                                : isPlus
                                    ? `${currentCount}+`
                                    : currentCount.toFixed(1);

                    newCounts[index] = formattedNumber;
                    return newCounts;
                });
            }, 50);

            return interval;
        });

        return () => intervals.forEach(clearInterval);
    }, [isVisible, success_texts]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                const entry = entries[0];
                if (entry.isIntersecting) {
                    setIsVisible(true); 
                    observer.disconnect(); // Run only once
                }
            },
            {
                threshold: 0.3, // 30% visibility to trigger
            }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                // eslint-disable-next-line
                observer.unobserve(sectionRef?.current);
            }
        };
    }, []);


    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        setIsReady(true); // Re-renders component once mounted
    }, []);


    return (
        <>
            <div className="front-pages">
                <section className="home-banner position-relative common-padd-xl">
                    <div className="homeLine"><img src={HomeLine} alt="line icon" /></div>
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                <div className="home-banner-info">
                                    {/* <h1>The <span>Easiest Way</span> to <br />Get Your New Job.</h1> */}
                                    {responseData[0]?.type === "text" && responseData[0]?.content && (
                                        <h1>{sanitizeData(responseData[0]?.content)}</h1>
                                    )}
                                    {responseData[1]?.type === "textarea" && responseData[1]?.content && (
                                        <p>{responseData[1]?.content}</p>
                                    )}

                                    <Form className={`homesearch mt-5 ${error && "error-border"}`} onSubmit={handleSubmit}>
                                        <Form.Group className={`iconinside border-right ${error && "error-border-inp"}`}>
                                            <div className="icon">
                                                <img src={BriefcaseIcon} alt="Briefcase Icon" />
                                            </div>
                                            <Form.Control
                                                type="text"
                                                placeholder="Keyword or Job title"
                                                name="industry"
                                            />
                                        </Form.Group>
                                        <Form.Group className={`iconinside ${error && "error-border-inp"}`}>
                                            <div className="icon">
                                                <img src={LocationIcon} alt="Location Icon" />
                                            </div>
                                            <Form.Control
                                                type="text"
                                                placeholder="Location"
                                                name="location"
                                            />
                                        </Form.Group>
                                        <Button className="btn btn-black w-100" type="submit">
                                            <img src={SearchIcon} alt="Search Icon" /> Search
                                        </Button>
                                    </Form>
                                    {/* {error && <Alert variant="danger">{error}</Alert>} */}
                                </div>
                            </div>
                            <div className="col-lg-6">
                                {responseData[3]?.type === "image" && responseData[3]?.content && (
                                    <div className="homeBanner">
                                        <img src={responseData[3]?.content} alt="banner graphics" />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="plusicon"><img src={PlusIcon} alt="plus icon" /></div>
                </section>

                <section className="brandlogo-area common-padd">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                <div className="brandlogo-title">
                                    <h2>{responseData[2]?.content}</h2>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                {(!isReady || !brand_logos || brand_logos.length < 3) ? <Loader /> :
                                    (<div className="brandSlider">
                                        <Swiper
                                            modules={[Autoplay, FreeMode]}
                                            loop={true}
                                            freeMode={true}
                                            autoplay={{
                                                delay: 0,
                                                disableOnInteraction: false,
                                            }}
                                            slidesPerView={2}
                                            speed={5000}
                                            grabCursor={true}
                                            loopAdditionalSlides={brand_logos.length > 4 ? 4 : 1} // Ensures a smoother loop
                                            allowTouchMove={brand_logos.length > 3} // Prevents interaction stopping autoplay
                                        >

                                            {brand_logos ? (brand_logos.map((brd: any, index: any) => (
                                                <SwiperSlide key={index}>
                                                    <div className="brandSlider-holder" >
                                                        <img key={index} src={brd[0]?.content} alt="brand logo" />
                                                    </div>
                                                </SwiperSlide>
                                            ))
                                            ) : (
                                                <Loader />
                                            )}
                                        </Swiper>
                                    </div>)}
                            </div>
                        </div>
                    </div>
                </section>

                <section className="recruitment-area position-relative common-padd-xl pb-0">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                <div className="recruitment-info">
                                    <h2>{sanitizeData(responseData[5]?.content)}</h2>
                                    {sanitizeData(responseData[6]?.content)}
                                    <h6>{responseData[7]?.content}</h6>
                                    <ul className="ticklist">
                                        {repeater_texts ? (repeater_texts.map((rep: any, index: any) => (
                                            <li key={index}>{rep[0]?.content}</li>
                                        ))
                                        ) : (
                                            <Loader />
                                        )}
                                    </ul>
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                    <Link to={isLoggedIn ? '' : '/employer'} className="btn mt-3">{responseData[12]?.content}</Link>
                                </div>
                            </div>
                            <div className="col-lg-6 bundle-flex-right">
                                <div className="bundleImg-holder">
                                    <div className="row align-items-end mb-4">
                                        <div className="col-lg-6">
                                            {responseData[8]?.type === "image" && (
                                                <div className="galleryImg1">
                                                    <img src={responseData[8]?.content} alt="img 1" />
                                                </div>
                                            )}
                                        </div>
                                        <div className="col-lg-6">
                                            {responseData[9]?.type === "image" && (
                                                <div className="galleryImg2">
                                                    <img src={responseData[9]?.content} alt="img 2" />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-12">
                                            {responseData[10]?.type === "image" && (
                                                <div className="galleryImg3">
                                                    <img src={responseData[10]?.content} alt="img 3" />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="focuslineBg"><img src={FocusLine} alt="line" /></div>
                </section>

                <section className="category-area common-padd-xl">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 text-center">
                                {/* <h2><span>Browse</span> By Category</h2> */}
                                {responseData[13]?.type === "text" && (
                                    <h2>{sanitizeData(responseData[13]?.content)}</h2>
                                )}

                                <div className="sliderCategory mt-5">
                                    <Swiper
                                        modules={[Navigation, Pagination, Autoplay]}
                                        spaceBetween={35}
                                        slidesPerView={5}
                                        navigation
                                        //pagination={{ clickable: true }}
                                        //scrollbar={{ draggable: true }}


                                        // spaceBetween={30}
                                        // slidesPerView={4}
                                        // navigation
                                        // modules={[Navigation]}
                                        breakpoints={{
                                            300: {
                                                slidesPerView: 1,
                                                spaceBetween: 0,
                                            },
                                            1024: {
                                                slidesPerView: 3,
                                                spaceBetween: 25,
                                            },
                                            1280: {
                                                slidesPerView: 4,
                                                spaceBetween: 30,
                                            },
                                            1367: {
                                                slidesPerView: 5,
                                                spaceBetween: 35,
                                            },
                                        }}
                                    >
                                        {categoryData ? (categoryData.map((catgry: any, index: any) => (
                                            <SwiperSlide key={index}>
                                                <div className="categoryIcon">
                                                    {catgry?.categoryImage && (
                                                        <img src={catgry?.categoryImage} alt="icon" />
                                                    )}
                                                </div>
                                                <div className="howmuchjobs">
                                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                                    <a href="#" onClick={() => handleJobCategorySearch(catgry?.id)}>{catgry?.jobCount} Jobs Found</a>
                                                </div>
                                                <h3>{catgry?.categoryName}</h3>
                                                <p>{catgry?.categoryDescription}</p>
                                            </SwiperSlide>
                                        ))) : (<Loader />)}

                                    </Swiper>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="nameSeen-area position-relative common-padd-xl">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6 order-2">
                                <div className="recruitment-info">
                                    <h2>{sanitizeData(responseData[17]?.content)}</h2>
                                    <p>{responseData[18]?.content}</p>
                                    <h6>{responseData[19]?.content}</h6>
                                    <ul className="ticklist">
                                        {network_texts ? (network_texts.map((net: any, index: any) => (
                                            <li key={net[0]?._id}>{net[0]?.content}</li>
                                        ))) : (<Loader />)}
                                    </ul>
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                    <Link to={isLoggedIn ? '' : '/employer'} className="btn">Hire Talent</Link>
                                </div>
                            </div>
                            <div className="col-lg-6 bundle-flex-left">
                                <div className="bundleImg-holder">
                                    <div className="row align-items-end mb-4">
                                        <div className="col-lg-6"><div className="galleryImg1"><img src={responseData[14]?.content} alt="img 1" /></div></div>
                                        <div className="col-lg-6"><div className="galleryImg2"><img src={responseData[15]?.content} alt="img 2" /></div></div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-12"><div className="galleryImg3"><img src={responseData[16]?.content} alt="img 3" /></div></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="nameseenline"><img src={NameSeenline} alt="line" /></div>
                </section>

                <section ref={sectionRef} className="results-area common-padd-xl">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 text-center mb-5">
                                <h2>{responseData[22]?.content}</h2>
                            </div>
                        </div>
                        <div className="row">
                            {success_texts ? (success_texts.map((scs: any, index: number) => (
                                <div key={index} className="col-lg-3 col-md-6 grothResults">
                                    {/* <h2>{scs[0]?.content}</h2> */}
                                    <h2 className="text-3xl font-bold">
                                        {counts[index]}
                                    </h2>
                                    <p>{scs[1]?.content}</p>
                                </div>
                            ))) : (<Loader />)}

                        </div>
                    </div>
                </section>

            </div>
        </>
    )
}
export default Home;